module.exports = __webpack_public_path__ + "static/media/purple_homepage_background.d41fa779.png";